/**
 * The live work-order chip: the active order and its checklist, ticking as
 * the journal fills. Bottom-left, out of the way of the crosshair and the
 * tool HUD. React edition of ui/WorkOrders.ts's missionChip.
 */

import type { CSSProperties } from 'react'
import { missionState } from '../../learn/missionState'
import { dialogStore } from '../ui/dialogStore'
import { missionObjectiveLabel, missionTitle } from '../../ui/WorkOrders'
import { useLang } from '../i18n/LanguageProvider'
import { useMissionTick } from '../state/hooks'

const chipStyle: CSSProperties = {
  position: 'fixed',
  left: 14,
  bottom: 40,
  zIndex: 30,
  maxWidth: 300,
  background: 'rgba(18, 20, 24, 0.86)',
  border: '1px solid rgba(255, 255, 255, 0.13)',
  borderRadius: 6,
  padding: '10px 13px',
  fontSize: 12,
  lineHeight: 1.5,
  color: '#dfe3e8',
  backdropFilter: 'blur(4px)',
}

export function MissionChip() {
  useLang()
  useMissionTick()
  const p = missionState.progress()
  if (!p) return null
  return (
    <div style={chipStyle}>
      <div style={{ fontWeight: 600, fontSize: '12.5px', marginBottom: 5 }}>
        {missionTitle(p.mission)}
      </div>
      {p.mission.objectives.map((o, i) => (
        <div key={o.id} style={{ display: 'flex', gap: 7, alignItems: 'baseline', margin: '2px 0' }}>
          <span style={{ flex: 'none', color: p.met[i] ? '#4fae6d' : '#8a9099' }}>
            {p.met[i] ? '✓' : '○'}
          </span>
          {/* A decision on the line is made in the Line dialog, so the objective
              that asks for it is the way there - the one row on the chip that
              is a link, because it is the one objective with no place on the
              floor to walk to. */}
          {!p.met[i] && o.criterion.kind === 'lineDecision' ? (
            <button
              type="button"
              onClick={() => dialogStore.open({ kind: 'line' })}
              style={{ background: 'none', border: 0, padding: 0, font: 'inherit', color: '#8ab4f8', textAlign: 'left', cursor: 'pointer', textDecoration: 'underline' }}
            >
              {missionObjectiveLabel(p.mission, i)}
            </button>
          ) : (
            <span style={p.met[i] ? { color: '#9aa2ab', textDecoration: 'line-through' } : undefined}>
              {missionObjectiveLabel(p.mission, i)}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}
